/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerReadQueryResponse, BidLevelingsControllerReadPathParams, BidLevelingsControllerReadQueryParams, BidLevelingsControllerRead400, BidLevelingsControllerRead401, BidLevelingsControllerRead403, BidLevelingsControllerRead404 } from "../../models/bidsController/BidLevelingsControllerRead";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { bidLevelingsControllerRead } from "../../clients/bidsService/bidLevelingsControllerRead";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const bidLevelingsControllerReadQueryKey = (id: BidLevelingsControllerReadPathParams["id"], params: BidLevelingsControllerReadQueryParams = {}) => [{
  url: '/api/v1/bid-levelings/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type BidLevelingsControllerReadQueryKey = ReturnType<typeof bidLevelingsControllerReadQueryKey>;
export function bidLevelingsControllerReadQueryOptions(id: BidLevelingsControllerReadPathParams["id"], params?: BidLevelingsControllerReadQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = bidLevelingsControllerReadQueryKey(id, params);
  return queryOptions<BidLevelingsControllerReadQueryResponse, ResponseErrorConfig<BidLevelingsControllerRead400 | BidLevelingsControllerRead401 | BidLevelingsControllerRead403 | BidLevelingsControllerRead404>, BidLevelingsControllerReadQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return bidLevelingsControllerRead(id, params, config);
    }
  });
}

/**
 * @description Pass include=rows,bidders,bidders.currentSubmission,cells,questions,suggestions,pendingSubmissions to get the whole grid in one request.
 * @summary Read a trade's grid
 * {@link /api/v1/bid-levelings/:id}
 */
export function useBidLevelingsControllerRead<TData = BidLevelingsControllerReadQueryResponse, TQueryData = BidLevelingsControllerReadQueryResponse, TQueryKey extends QueryKey = BidLevelingsControllerReadQueryKey>(id: BidLevelingsControllerReadPathParams["id"], params?: BidLevelingsControllerReadQueryParams, options: {
  query?: Partial<QueryObserverOptions<BidLevelingsControllerReadQueryResponse, ResponseErrorConfig<BidLevelingsControllerRead400 | BidLevelingsControllerRead401 | BidLevelingsControllerRead403 | BidLevelingsControllerRead404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? bidLevelingsControllerReadQueryKey(id, params);
  const query = useQuery({
    ...bidLevelingsControllerReadQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BidLevelingsControllerRead400 | BidLevelingsControllerRead401 | BidLevelingsControllerRead403 | BidLevelingsControllerRead404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}